import AccountBoxIcon from '@mui/icons-material/AccountBox';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import HomeIcon from '@mui/icons-material/Home';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import MailIcon from '@mui/icons-material/Mail';
import PageviewIcon from '@mui/icons-material/Pageview';
import PersonIcon from '@mui/icons-material/Person';
import TodayIcon from '@mui/icons-material/Today';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { dictionary } from './dictionary';
import { paths } from './routes';

interface AppNavigationItem {
  title: string;
  path: string;
  icon: any;
  items?: AppNavigationItem[];
}

export const navigation: AppNavigationItem[] = [
  { title: dictionary.HOME, path: paths.HOME, icon: <HomeIcon /> },
  { title: dictionary.ASSETS, path: paths.ASSETS_LIST, icon: <DynamicFormIcon /> },
  { title: dictionary.EMAIL_REPORTS, path: paths.EMAIL_REPORT_LIST, icon: <MailIcon /> },
  { title: dictionary.OPCCLIENT, path: paths.OPCCLIENT_LIST, icon: <AccountBoxIcon /> },
  { title: dictionary.SHIFTS, path: paths.SHIFTS_LIST, icon: <TodayIcon /> },
  { title: dictionary.GROUPS, path: paths.GROUP_LIST, icon: <GroupWorkIcon /> },
  { title: dictionary.LOCAL_USERS, path: paths.LOCAL_USER, icon: <PersonIcon /> },
  { title: dictionary.BROWSE_OPC_UA, path: paths.BROWSE_OPC_UA, icon: <PageviewIcon /> },
  { title: dictionary.PERMISSIONS, path: paths.PERMISSION, icon: <VerifiedUserIcon /> },
  { title: dictionary.APP_INFO, path: paths.APP_INFO, icon: <InfoOutlinedIcon /> },
];
